import { useState } from "react";

import InstrumentSelect from "../select/InstrumentSelect";
import DatePicker from "../dateTimePickers/datePicker";
import dayjs from "dayjs";
import moment from "moment";
import useWindowDimensions from "../../utils/width";

const InstrumentAnalyticsByDate = ({ trades, runSpeficCal, theme, showGross = false }) => {
  const [pair, setPair] = useState("");
  const [start, setStart] = useState(dayjs(new Date()));
  const [end, setEnd] = useState(dayjs(new Date()));

  const { width } = useWindowDimensions();
  const isDark = theme[0] === "dark";
  const win = "#26a65d";
  const loss = "#f23645";
  const breakeven = "#ED9E0E";

  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "12px",
        width: "100%",
        maxWidth: "770px",
        backgroundColor: isDark ? "#1e1f23" : "#ffffff",
        border: `1px solid ${isDark ? "#2d2e33" : "#e5e7eb"}`,
        marginTop: "16px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          fontSize: width <= 700 ? "16px" : "18px",
          fontWeight: "600",
          color: isDark ? "#e5e7eb" : "#374151",
          marginBottom: "16px",
        }}
      >
        Instrument Analytics By Date
      </div>
      <div
        style={{
          margin: "30px auto 10px auto",
          display: "flex",
          justifyContent: "space-around",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "40%",
          }}
        >
          <DatePicker
            size="small"
            label="Start"
            value={start}
            onChange={(newValue) => setStart(newValue.$d)}
          />
        </div>
        <div
          style={{
            width: "40%",
          }}
        >
          <DatePicker
            defaultValue={end}
            size="small"
            label="End"
            value={end}
            onChange={(newValue) => setEnd(newValue.$d)}
          />
        </div>
      </div>
      <table
        style={{
          tableLayout: "fixed",
          borderCollapse: "collapse",
          width: "100%",
          height: "120px",
          fontSize: width <= 700 ? "13px" : "18px",
          margin: "0 auto",
        }}
      >
        <thead
          className="tableHoverEffectOff"
          style={{ fontSize: width <= 700 ? "13px" : "16px", height: "50px" }}
        >
          <tr>
            <th style={{ fontWeight: "400", width: "150px" }}>Instrument</th>
            <th style={{ fontWeight: "400", color: win }}>Win</th>
            <th style={{ fontWeight: "400", color: breakeven }}>BE</th>
            <th style={{ fontWeight: "400", color: loss }}>Loss</th>
            <th style={{ fontWeight: "400" }}># Trades</th>
            <th style={{ fontWeight: "400" }}>Return %</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ textAlign: "center" }}>
            <th style={{ fontWeight: "400" }} scope="row">
              <InstrumentSelect
                value={pair}
                onChange={(event) => {
                  setPair(event.target.value);
                }}
                size="small"
                fullWidth
              />
            </th>

            <td style={{ color: win }}>
              {
                trades.filter(
                  (p) =>
                    p.pair === pair &&
                    (p.outcomePC === "Win" ||
                      p.outcomeIC === "Win") &&
                    moment(moment(p.entryDate, "DD/MM/YY")).isBetween(
                      moment(start),
                      moment(end)
                    )
                ).length
              }
            </td>

            <td style={{ color: breakeven }}>
              {
                trades.filter(
                  (p) =>
                    p.pair === pair &&
                    (p.outcomePC === "Breakeven" ||
                      p.outcomeIC === "Breakeven") &&
                    moment(moment(p.entryDate, "DD/MM/YY")).isBetween(
                      moment(start),
                      moment(end)
                    )
                ).length
              }
            </td>
            <td style={{ color: loss }}>
              {
                trades.filter(
                  (p) =>
                    p.pair === pair &&
                    (p.outcomePC === "Loss" ||
                      p.outcomeIC === "Loss") &&
                    moment(moment(p.entryDate, "DD/MM/YY")).isBetween(
                      moment(start),
                      moment(end)
                    )
                ).length
              }
            </td>
            <td>
              {
                trades.filter(
                  (p) =>
                    p.pair === pair &&
                    moment(moment(p.entryDate, "DD/MM/YY")).isBetween(
                      moment(start),
                      moment(end)
                    )
                ).length
              }
            </td>
            {runSpeficCal(
              trades.filter(
                (p) =>
                  p.pair === pair &&
                  moment(moment(p.entryDate, "DD/MM/YY")).isBetween(
                    moment(start),
                    moment(end)
                  )
              ),
              false,
              showGross
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default InstrumentAnalyticsByDate;
